import { html } from "htm/preact";
import { useState } from "preact/hooks";
import { Chevron } from "./icons";

export const Dropdown = ({ icon, title, hasChevron = false, children, className }) => {
  const [isActive, setActive] = useState(false);
  const activeClass = isActive ? "flex" : "hidden";
  return html`
    <div class="relative ${className}">
      <button
        class="mx-3 button button-black flex"
        onClick="${() => setActive(!isActive)}"
        onBlur="${() => setActive(false)}"
      >
        ${icon}
        <span class="${icon && "ml-2"} ${hasChevron && "mr-2"}">${title}</span>
        ${hasChevron && html`<${Chevron} direction="${isActive ? "up" : "down"}" />`}
      </button>
      <ul class="${activeClass} flex-col absolute left-0 right-0 mt-3 max-h-64 overflow-y-auto shadow">
        ${children}
      </ul>
    </div>
  `;
};

